module.exports = __webpack_public_path__ + "img/banner-active.5b60d433.svg";